import { H3 } from '@/components/sv/typographies'
import { CardContent, CardDescription, CardHeader } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'

export const WebhookAnalyticsSectionFallback = () => (
  <div className="grid grid-cols-2">
    <div>
      <CardHeader className="py-6">
        <H3>Event deliveries</H3>
        <CardDescription>
          <div className="flex gap-6 mt-2">
            <div className="flex items-center gap-2">
              <div className="bg-[var(--chart-2)] w-4 h-4 rounded-sm" />
              <Skeleton className="w-20 h-5.5" />
            </div>
            <div className="flex items-center gap-2">
              <div className="bg-[var(--chart-1)] w-4 h-4 rounded-sm" />
              <Skeleton className="w-20 h-5.5" />
            </div>
          </div>
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <Skeleton className="h-60 w-full" />
      </CardContent>
    </div>
    <div>
      <CardHeader className="py-6">
        <H3>Response time</H3>
        <CardDescription>
          <div className="flex items-center gap-2 mt-2">
            <div className="bg-[var(--chart-3)] w-4 h-4 rounded-sm" />
            <Skeleton className="w-20 h-5.5" />
          </div>
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <Skeleton className="h-60 w-full" />
      </CardContent>
    </div>
  </div>
)
